//-------Theme-----//
//Polyfill
ttiPolyfill.getFirstConsistentlyInteractive().then(console.log);
ttiPolyfill.getFirstConsistentlyInteractive().then((tti) => {    
    var myInterval = setInterval(function()  {
    if( typeof ga !== 'undefined' )
        {            
        ga('send', 'event', {
            eventCategory: 'Performance Metrics',
            eventAction: 'TTI',
            eventValue: tti,
            eventLabel: tti,
            nonInteraction: true,
        });
        clearInterval(myInterval);
        console.log("Performance Metrics(assets) is " + tti);
        }
    }, 10);
});
//-------END Theme-----//

//-------Header-----//
var currentChangePropTopHref;
function showPopupPropTop(_event, _this) {
    _event.preventDefault();
    _event.stopPropagation();
    var _href = _this.getAttribute('href');
    if (/\/pages\/why-shop-at-everydayyoga-com/i.test(_href)) {
        _href = "/pages/why-shop-at-everydayyoga";
    }
    if ($("#semodal-modal-container").length && currentChangePropTopHref == _href) {
        $("body").addClass("semodal-modal-open");
        $("#semodal-modal-modal").scrollTop(0);
    } else {
        $("#semodal-modal-overlay").remove();
        $("#semodal-modal-container").remove();
        currentChangePropTopHref = _href;
        $.ajax({
            url: _href,
            type: "GET",
            success: function (response) {
                $('body').addClass("semodal-modal-open");
                $('body').append(response);
                $("#semodal-semodal-modal-close").on("click", function (e) {
                    e.preventDefault();
                    $('body').removeClass("semodal-modal-open");
                });
            }
        });
    }
}
var slideIndex = 1;
var propValueInterval;
var propValueStopper = false;
function carousel() {
   
     var i;
     var x = $(".value-prop > li");
     for (i = 0; i < x.length; i++) {
         $(x[i]).fadeOut(700);
     }
     slideIndex++;
     if (slideIndex > x.length) { slideIndex = 1 }
     $(x[slideIndex - 1]).delay(850).fadeIn(700);
   
}
var urlAbtest = new URLSearchParams(window.location.search.toLowerCase());
     var abtest = urlAbtest.get('abtest') == "y" ? "Y" : "";
     abtest  ="Y";
     var check_status = "";
      var VALUE_PROP_FLICKITY_OPTIONS = {
        prevNextButtons: true,
        cellAlign: 'center',
        contain: true,
        dragThreshold: 8,
        groupCells: 1,
        autoPlay: 6000,
        initialIndex: 0,
        lazyLoad: false,
        pageDots: false,
        setGallerySize: true,
        watchCSS: false,
        wrapAround: true,
        arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 }
      };

      window.initEyValuePropCarousel = window.initEyValuePropCarousel || function () {
        var carouselEl = document.getElementById('value_prop_carousel');
        if (!carouselEl || !window.Flickity) {
          return false;
        }
        if (window.__eyValuePropFlickity) {
          window.__eyValuePropFlickity.resize();
          return true;
        }
        if (carouselEl.classList.contains('flickity-enabled')) {
          var existing = window.Flickity.data(carouselEl);
          if (existing) {
            window.__eyValuePropFlickity = existing;
            existing.resize();
            return true;
          }
        }
        var cells = carouselEl.querySelectorAll('.Carousel__Cell');
        if (cells.length <= 1) {
          return true;
        }
        window.__eyValuePropFlickity = new window.Flickity(carouselEl, VALUE_PROP_FLICKITY_OPTIONS);
        return true;
      };

      var fheaderInitAttempts = 0;
      var fheader_init = function (version, callback, loop) {
          var ready = window.jQuery && window.Flickity;
          if (loop) {
              if (ready) {
                  loop.callback();
              } else if (fheaderInitAttempts < 50) {
                  fheaderInitAttempts += 1;
                  setTimeout(fheader_init.bind(null, version, callback, loop), 100);
              }
              return;
          }

        if (ready) {
            if (version == "Y") {
              window.initEyValuePropCarousel();
            } else {
              var windowWidth = $(window).width();
                if (windowWidth < 1024) {
                    if (!propValueStopper) {
                        propValueStopper = true;
                        propValueInterval = setInterval(carousel, 4250);
                    }
                } else {
                    propValueStopper = false;
                    clearInterval(propValueInterval);
                    $(".value-prop > li").show();
                }
            }
        } else if (fheaderInitAttempts < 50) {
            fheaderInitAttempts += 1;
            setTimeout(fheader_init.bind(null, version, callback, loop), 100);
        }
        callback && callback(version);
    };
    var fheader_check = function(callback, timeout) {
    timeout = timeout != null ? timeout : 2000;
    let timeout_id = setTimeout(function () { fmain(); }, timeout);
    let fmain = () => {
        console.log(`[ SAYT ] status: ${check_status}, is-which-one: ${window['isWhichOne']}`);
        if (check_status != "finish") {
            if (window['isWhichOne'] == "N") { abtest = "Y"; }
            check_status == "finish";
            fheader_init(abtest, callback);
        }
    };
    if (check_status == "") {
        check_status = "start";
        let gtag = window['gtag'];
        if (typeof gtag === "undefined") {
            gtag = function() { }
        }
        gtag('event', 'optimize.callback', {
            name: 'iQZz0VN7RlysI1NfqqOTyg' /* prod: 'NSiYjp2iSnaMHrPZfHLm2A', stag: 'NSiYjp2iSnaMHrPZfHLm2A' */,
            callback: function (value) {
                console.log(`[ SAYT ] optimize.callback, value: ${value}, timeout-id: ${timeout_id}`);              
                fmain();
                clearTimeout(timeout_id);
            }
        });
        
    }
}

      function propValueAmination() {       
            fheader_init(abtest);        
 
      }
var isJQready = setInterval(function () {
    if (window.jQuery) {
        clearInterval(isJQready);
        console.log('jQuery(value-prop-top) is ready!');
        var valuePropResizeTimer;
        $(window).on('resize', function () {
            clearTimeout(valuePropResizeTimer);
            valuePropResizeTimer = setTimeout(function () {
              if (window.__eyValuePropFlickity) {
                window.__eyValuePropFlickity.resize();
              }
            }, 150);
        });
        $(document).ready(function () {
            propValueAmination();
            $( window ).scroll(function() {
                if($(window).scrollTop() >= 10) {
                      $("#header-abtest").addClass("Header-scrollable");
                } else {
                      $("#header-abtest").removeClass("Header-scrollable");
                }
                if (typeof window.syncEyHeaderAbtestHeight === 'function') {
                      window.syncEyHeaderAbtestHeight();
                      window.requestAnimationFrame(window.syncEyHeaderAbtestHeight);
                }
               });
        });
    }
}, 100);
//-------END Header-----//

//-------Footer-----//
//Flickity
setTimeout(function () {
    var flky12 = new Flickity('#foot_feature_item', {
        prevNextButtons: false,
        cellAlign: 'center',
        contain: true,
        dragThreshold: 8,
        groupCells: true,
        initialIndex: 0,
        lazyLoad: true,
        pageDots: false,
        setGallerySize: true,
        watchCSS: false,
        wrapAround: false,
        arrowShape: { "x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25 }
    });
}, 1000);

//isJQreadyFooter interval
var isJQreadyFooter = setInterval(function () {
    if (window.jQuery) {
        clearInterval(isJQreadyFooter);
        console.log('jQuery(footer) is ready!');
        $(function () {
            $(".Footer__Block--links").each(function () {
                $(this).bind("click", function () {
                    if ($(this).hasClass("open-mobile")) {
                        $(this).removeClass("open-mobile");
                    } else {
                        $('.Footer__Block--links').removeClass("open-mobile");
                        $(this).addClass("open-mobile");
                    }
                })
            });
        });
    }
}, 100);
//-------END Footer-----//